// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2ffa7ex19Eoxvc {\n  height: 100%;\n  position: relative;\n  z-index: 0;\n}\n.B2pjxM9szBETMN {\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 80;\n}\n._1dgLn3N_HDFjr6 {\n  position: fixed;\n  right: 4px;\n  top: 40px;\n  z-index: 2;\n  max-width: 270px;\n}\n._31OAYSpzwpVMvO {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n}\n._3epPV3cKVbb994 {\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 70;\n}\n._1Tu3qvTvmJuddW {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appLayer": "_2ffa7ex19Eoxvc",
	"overlayLayer": "B2pjxM9szBETMN",
	"alertLayer": "_1dgLn3N_HDFjr6",
	"flagLayer": "_31OAYSpzwpVMvO",
	"popoverLayer": "_3epPV3cKVbb994",
	"tooltipLayerRef": "_1Tu3qvTvmJuddW"
};
export default ___CSS_LOADER_EXPORT___;
